// extracted by mini-css-extract-plugin
export var deliveryRow = "_t4-a";
export var fixedHeight = "_t4-4";
export var freightLogo = "_t4-9";
export var fullWidth = "_t4-3";
export var priceColumn = "_t4-5";
export var radioSelected = "_t4-7";
export var radioUnselected = "_t4-6";
export var selectedOption = "_t4-2";
export var selectedOptionContainer = "_t4-1";
export var selection = "_t4-0";
export var tallSkeletonText = "_t4-8";